import {
  DotPath
} from '../getOrElse'

export type Getter<R, T> = (root: R, path: DotPath, orElse?: T) => T

export const isValid = <R>(
  ptr: R,
  curr: string,
  requireDefined: boolean
): boolean => requireDefined === true ?
    ptr[curr] !== undefined && ptr[curr] !== null :
    curr in ptr

export const get = <R>(
  root: R, path = '',
  orElse = undefined,
  requireDefined = true
) => {
  if (path === '') {
    return root
  }
  else {
    return path.split('.').reduce((acc, curr, idx) => {
      const ptr = idx === 0 ? root : acc
      const isObject = ptr !== null && typeof ptr === 'object'
      const value = isObject &&
        isValid(ptr, curr, requireDefined) ?
        ptr[curr] : orElse
      return value
    }, orElse)
  }
}

export default function getElse<R, T>(root: R, path: DotPath, orElse?: T) {
  return typeof path === 'string'
    ? get(Object(root), path, orElse)
    : multiPathsGetOrElse(Object(root), path, orElse)
}

/**
 * Of note, this actually seems redundant. Probably okay to remove.
 *
 * @param root Source object
 * @param path Expected path
 * @param orElse Return if undefined
 *
 */
export function getDefinedOrElse<R, T>(
    root: R,
    path: DotPath,
    orElse?: T
) {
  return typeof path === 'string'
    ? get(Object(root), path, orElse, true)
    : multiPathsGetOrElse(Object(root), path, orElse)
}

export function multiPathsGetOrElse<R, T>(
  root: R,
  dotPaths: string[],
  orElse: T
): T {
  const found = dotPaths
    .map(path => get(root, path, undefined, true))
    .find(gotten => gotten !== undefined)
  return found !== undefined ? found : orElse
}
